export const navigation = {
	header: {
		title: "Todas las categorías",
		searchTooltip: "Buscar categorías",
		addCategoryTooltip: "Agregar categoría",
		showZeroProductCategoriesTooltip: "Mostrar categorías sin productos",
		hideZeroProductCategoriesTooltip: "Ocultar categorías sin productos",
		showEmptyCategories: "Mostrar categorías sin productos",
		hideEmptyCategories: "Ocultar categorías sin productos",
		show: "Mostrar",
		hide: "Ocultar",
	},
	search: {
		placeholder: "Buscar categoría",
		closeTooltip: "Cerrar búsqueda",
	},
	subcategories: {
		levelPrefix: "Nivel",
	},
	priorityLabel: "Nivel",
	categoryDisabledTooltip: "No se pueden agregar productos a esta categoría",
	loadingCategories: "Cargando categorías",
	emptyState: {
		noSearchResults: {
			title: "No se encontraron categorías",
			message: "No encontramos categorías que coincidan con tu búsqueda de",
		},
		noCategories: {
			title: "No hay categorías creadas",
			message:
				"Aún no tienes categorías de productos. Crea tu primera categoría para organizar tus productos.",
		},
		noCategoriesWithFilters: {
			title: "Las categorías están ocultas",
			message:
				"No existen categorías que correspondan a tus filtros actuales. Haz clic para mostrar todas las categorías o elimina los filtros.",
		},
		clearSearchButton: "Limpiar búsqueda",
		createCategoryButton: "Crear categoría",
		showHiddenCategoriesButton: "Mostrar categorías",
	},
};
